export default "__VITE_ASSET__CsuzYcRx__"